const initCollectPoint = {
  collectPoints: [],
  currentPage: 1,
  totalPage: 1,
  limitPage: 10,
  lengthPage: 1,
  searchValue: "",
  filterTenantPage: "",
  isFormLoading: false,
  isImportLoading: false,
};

export const collectPointReducer = (state = initCollectPoint, action: any) => {
  if (action.type === "SET_COLLECT_POINT") {
    return {
      ...state,
      collectPoints: action.value,
    };
  }
  if (action.type === "SET_COLLECT_POINT_CURRENT_PAGE") {
    return {
      ...state,
      currentPage: action.currentPage,
    };
  }
  if (action.type === "SET_COLLECT_POINT_PAGE") {
    return {
      ...state,
      totalPage: action.totalPage,
      limitPage: action.limitPage,
      lengthPage: action.lengthPage,
    };
  }
  if (action.type === "SET_SEARCH_COLLECT_POINT") {
    return {
      ...state,
      searchValue: action.searchValue,
    };
  }
  if (action.type === "SET_COLLECT_POINT_FILTER_PAGE") {
    return {
      ...state,
      filterTenantPage: action.filterTenantPage,
    };
  }
  if (action.type === "SET_FORM_LOADING") {
    return {
      ...state,
      isFormLoading: action.value,
    };
  }
  if (action.type === "SET_IMPORT_LOADING") {
    return {
      ...state,
      isImportLoading: action.value,
    };
  }
  return state;
};
